import { ICellEditorParams } from '@ag-grid-community/core'
import { Autocomplete, CircularProgress, TextField } from '@mui/material'
import { useContext } from 'react'

import { DomainContext } from '../contexts/DomainContext'

interface CompanySelectorProps {
    params: ICellEditorParams
}

export default function CompanySelector({ params }: CompanySelectorProps) {
    const { companies, loading } = useContext(DomainContext)

    const handleChange = company => {
        const rowNode = params.node
        rowNode.setDataValue('company', company?.name ?? '--')
    }

    return (
        <Autocomplete
            key="companyId"
            size="small"
            loading={loading}
            value={companies?.find(c => c.name === params?.data?.company)}
            options={companies}
            getOptionLabel={option => option.name}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={params => (
                <TextField
                    {...params}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                    hiddenLabel
                    variant="standard"
                    name="companyId"
                />
            )}
            onChange={(e, company) => handleChange(company)}
        ></Autocomplete>
    )
}
